import React from 'react';

import ReportApi from 'api/report.jsx';

import Loader from 'components/loader.jsx';
import SeasonsUsageOptions from './seasonsUsageOptions.jsx';
import SeasonsUsageSummary from './seasonsUsageSummary.jsx';
import {FormattedMessage} from 'react-intl';

class SeasonsUsage extends React.Component {
  state = {
    filters: [],
    loaded: true,
    showNoDataMessage: false,
    history: null,
  };

  componentWillMount() {
    this.defaultFilters = {
      branch: 0,
      truBlueStatus: '',
      active: 'all',
    };
    this.setState({
      filters: this.defaultFilters,
      loaded: false,
    });

    ReportApi.getSeasonsUsageReportPDFHistory().then(d => {
      if (d !== null && d.Data) {
        d.Data = d.Data.split('|');
      }

      this.setState({
        history: d,
        loaded: true,
      });
    }).catch((e) => {
      console.log(e);
      this.setState({loaded: true});
    });
  }

  render() {
    return (
      <div className='report-container'>
        <span>
          <FormattedMessage id="reports.season.usage.description" />
        </span>
        <SeasonsUsageOptions branches={this.props.branches} defaultFilters={this.defaultFilters} truBlueActive={this.props.truBlueActive} />
        <Loader loaded={this.state.loaded}>
          <SeasonsUsageSummary
            filters={this.state.filters}
            showNoDataMessage={this.state.showNoDataMessage}
            history={this.state.history}
            branches={this.props.branches}
            truBlueActive = {this.props.truBlueActive}
          />
        </Loader>
      </div>
    );
  }
}

export default SeasonsUsage;
